import type { MiniAppProfile } from '../services/api';

type CoursePlan = NonNullable<MiniAppProfile['profile']['plan']>;

export function getCoursePresentation(coursePlan: CoursePlan | null | undefined) {
  const tone = coursePlan?.status === 'goal_reached' || coursePlan?.status === 'on_track' || coursePlan?.status === 'near_goal'
    ? 'positive'
    : coursePlan?.status === 'slower' || coursePlan?.status === 'faster' ? 'attention' : 'neutral';
  const title = coursePlan?.trendConfidence === 'low' ? 'Собираем данные' : coursePlan?.statusLabel || 'Стартовый план';
  const message = coursePlan?.trendConfidence === 'low'
    ? `Нужно ещё несколько измерений веса, чтобы понять реальную динамику${coursePlan?.trendMeasurementsCount ? `. Сейчас есть ${coursePlan.trendMeasurementsCount}` : ''}.`
    : coursePlan?.statusText || 'Noma уточнит курс, когда появятся новые данные.';
  const actualRate = coursePlan?.trendDeltaKg == null ? null : Math.abs(Number(coursePlan.trendDeltaKg));
  const expectedRange = coursePlan?.expectedWeeklyMinKg != null && coursePlan?.expectedWeeklyMaxKg != null
    ? `${Number(coursePlan.expectedWeeklyMinKg).toFixed(1)}–${Number(coursePlan.expectedWeeklyMaxKg).toFixed(1)} кг/нед.`
    : null;
  const mascotSrc = coursePlan?.status === 'goal_reached' || coursePlan?.status === 'near_goal'
    ? '/mascot/course/nomik-goal-v4.webp'
    : coursePlan?.trendConfidence === 'low'
      ? '/mascot/course/nomik-collecting-v4.webp'
      : coursePlan?.status === 'slower' || coursePlan?.status === 'faster'
        ? '/mascot/course/nomik-attention-v4.webp'
        : '/mascot/course/nomik-on-track-v4.webp';

  return { tone, title, message, actualRate, expectedRange, mascotSrc } as const;
}
